import apiConfig from "../ApiConfig";

export const fetchCustomerCommandCenter = async () => {
  const response = await apiConfig.get("/api/dashboard/command-center/");
  return response.data;
};